import React from 'react'
import {MenuLink} from '@src/modules/Layout/shared/MenuLink'
import {RECORDS_ROUTES} from '../../constants'
import {Icon} from '@therms/atalaya'
import {BiSolidBox} from 'react-icons/bi'

function RecordsMenuLink() {
  return (
    <MenuLink to={RECORDS_ROUTES.__ROOT__}>
      <div className="gap-x-sm inline-flex items-center">
        <Icon Icon={BiSolidBox} />
        <span>Records</span>
      </div>
    </MenuLink>
  )
}

export {RecordsMenuLink}